import { takeEvery, put, call, all, fork } from "redux-saga/effects";

// SMS Template action types
import {
  GET_SMS_TEMPLATE_LIST,
  GET_SMS_TEMPLATE_DATA,
  ADD_SMS_TEMPLATE,
  UPDATE_SMS_TEMPLATE,
  DELETE_SMS_TEMPLATE,
  SEND_SMS_OUTBOUND,
  GET_SMS_ADDRESS_BOOK,
} from "./actionType";

// SMS Template actions
import {
  getSmsTemplateListSuccess,
  getSmsTemplateListFail,
  getSmsTemplateDataSuccess,
  getSmsTemplateDataFail,
  addSmsTemplateSuccess,
  addSmsTemplateFail,
  updateSmsTemplateSuccess,
  updateSmsTemplateFail,
  deleteSmsTemplateSuccess,
  deleteSmsTemplateFail,
  sendSmsOutboundSuccess,
  sendSmsOutboundFail,
  getSmsAddressBookSuccess,
  getSmsAddressBookFail,
} from "./action";

// Include helper step with default methods
import {
  getSmsTemplatesApiCall,
  getSmsTemplateDetailsApiCall,
  addSmsTemplateApiCall,
  updateSmsTemplateApiCall,
  deleteSmsTemplateApiCall,
  sendSmsOutboundApiCall,
  getSmsAddressBookApiCall,
} from "../../helpers/fakebackend_helper";

// get SMS template list
function* onGetSmsTemplateList() {
  try {
    const response = yield call(getSmsTemplatesApiCall);

    if (response) {
      yield put(getSmsTemplateListSuccess(response));
    } else {
      yield put(getSmsTemplateListFail(response));
    }
  } catch (error) {
    yield put(getSmsTemplateListFail(error));
  }
}

export function* watchGetSmsTemplateList() {
  yield takeEvery(GET_SMS_TEMPLATE_LIST, onGetSmsTemplateList);
}

// get SMS template data
function* onGetSmsTemplateData({ payload }) {
  try {
    const response = yield call(getSmsTemplateDetailsApiCall, payload);

    if (response) {
      yield put(getSmsTemplateDataSuccess(response));
    } else {
      yield put(getSmsTemplateDataFail(response));
    }
  } catch (error) {
    yield put(getSmsTemplateDataFail(error));
  }
}

export function* watchGetSmsTemplateData() {
  yield takeEvery(GET_SMS_TEMPLATE_DATA, onGetSmsTemplateData);
}

// add SMS template
function* onAddSmsTemplate({ payload }) {
  try {
    const response = yield call(addSmsTemplateApiCall, payload);

    if (response) {
      yield put(addSmsTemplateSuccess(response));
    } else {
      yield put(addSmsTemplateFail(response));
    }
  } catch (error) {
    yield put(addSmsTemplateFail(error));
  }
}

export function* watchAddSmsTemplate() {
  yield takeEvery(ADD_SMS_TEMPLATE, onAddSmsTemplate);
}

// update SMS template
function* onUpdateSmsTemplate({ payload }) {
  try {
    const response = yield call(updateSmsTemplateApiCall, payload);

    if (response) {
      yield put(updateSmsTemplateSuccess(response));
    } else {
      yield put(updateSmsTemplateFail(response));
    }
  } catch (error) {
    yield put(updateSmsTemplateFail(error));
  }
}

export function* watchUpdateSmsTemplate() {
  yield takeEvery(UPDATE_SMS_TEMPLATE, onUpdateSmsTemplate);
}

// delete SMS template
function* onDeleteSmsTemplate({ payload }) {
  try {
    const response = yield call(deleteSmsTemplateApiCall, payload);

    if (response) {
      yield put(deleteSmsTemplateSuccess(response));
    } else {
      yield put(deleteSmsTemplateFail(response));
    }
  } catch (error) {
    yield put(deleteSmsTemplateFail(error));
  }
}

export function* watchDeleteSmsTemplate() {
  yield takeEvery(DELETE_SMS_TEMPLATE, onDeleteSmsTemplate);
}

// send SMS outbound
function* onSendSmsOutbound({ payload }) {
  try {
    const response = yield call(sendSmsOutboundApiCall, payload);

    if (response) {
      yield put(sendSmsOutboundSuccess(response));
    } else {
      yield put(sendSmsOutboundFail(response));
    }
  } catch (error) {
    yield put(sendSmsOutboundFail(error));
  }
}

export function* watchSendSmsOutbound() {
  yield takeEvery(SEND_SMS_OUTBOUND, onSendSmsOutbound);
}

// get SMS address book
function* onGetSmsAddressBook({payload}) {
  try {
    const response = yield call(getSmsAddressBookApiCall, payload);

    if (response) {
      yield put(getSmsAddressBookSuccess(response));
    } else {
      yield put(getSmsAddressBookFail(response));
    }
  } catch (error) {
    yield put(getSmsAddressBookFail(error));
  }
}

export function* watchGetSmsAddressBook() {
  yield takeEvery(GET_SMS_ADDRESS_BOOK, onGetSmsAddressBook);
}

// main Saga Function
function* smsSaga() {
  yield all([
    fork(watchGetSmsTemplateList),
    fork(watchGetSmsTemplateData),
    fork(watchAddSmsTemplate),
    fork(watchUpdateSmsTemplate),
    fork(watchDeleteSmsTemplate),
    fork(watchSendSmsOutbound),
    fork(watchGetSmsAddressBook),
  ]);
}

export default smsSaga;
